export default __webpack_public_path__ + "static/media/2322.2e534e21.png";